function AuditChangesModal({ log, close }) {
  const oldData = JSON.parse(log.old_data || '{}');
  const newData = JSON.parse(log.new_data || '{}');
  const fields = Object.keys({ ...oldData, ...newData });

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <div className="bg-white p-6 rounded w-3/4 max-h-[80vh] overflow-auto">
        <h2 className="text-lg font-semibold mb-4">Audit Changes</h2>

        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2">Field</th>
              <th className="p-2">Old Value</th>
              <th className="p-2">New Value</th>
            </tr>
          </thead>
          <tbody>
            {fields.map(f => (
              <tr key={f} className="border-t">
                <td className="p-2">{f}</td>
                <td className="p-2">{oldData[f]}</td>
                <td className="p-2">{newData[f]}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <button
          onClick={close}
          className="mt-4 px-4 py-2 bg-gray-200 rounded"
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default AuditChangesModal;